module.exports = __webpack_public_path__ + "img/c06_unitshieldbearer_Normal_ua.bf5a1041.webp";